<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between">
        <div class="d-flex align-center justify-center direction-row">
          <h6 class="text-h6 font-weight-bold ma-2">
            {{ $t("label.submission_info") }}
          </h6>
          <v-menu v-if="!readonly" class="ma-2" rounded offset-y>
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="success" outlined>
                투고 논문 불러오기
              </v-btn>
            </template> -->

            <v-list>
              <v-list-item
                link
                v-for="paper in previousPapers"
                :key="paper.idx"
                @click="selectPreviousPaper(paper)"
              >
                <v-list-item-title>{{
                  `[${paper.journal?.title}] ${paper.title}`
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <!-- <div class="d-flex align-center">
          <custom-button
            :label="$t('button.preview')"
            color="black"
            size="lg"
            gradient
            rounded
            @click="generatePdfPreview"
          />
        </div> -->
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" sm="12">
        <v-text-field
          :value="localPaper.journal.title"
          :label="$t('label.journal')"
          hide-details="auto"
          class="mb-4 ml-3"
          readonly
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="12"
        v-if="localPaper.submitted_at && readonly"
      >
        <v-text-field
          :value="localPaper.submitted_at"
          :label="$t('label.submitted_at')"
          hide-details="auto"
          class="mb-4 ml-3"
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <!-- 제목 -->
        <v-text-field
          :value="localPaper.title"
          :label="$t('label.title')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :rules="readonly ? [] : [rules.required]"
          :readonly="readonly"
          @input="updateField('title', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <!-- 제목(영문) -->
        <v-text-field
          :value="localPaper.title_eng"
          :label="$t('label.title_eng')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :rules="readonly ? [] : [rules.required]"
          :readonly="readonly"
          @input="updateField('title_eng', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <!-- 부제목(국문) -->
        <v-text-field
          :value="localPaper.subtitle"
          :label="$t('label.subtitle')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :readonly="readonly"
          @input="updateField('subtitle', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <!-- 부제목(영문) -->
        <v-text-field
          :value="localPaper.subtitle_eng"
          :label="$t('label.subtitle_eng')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :readonly="readonly"
          @input="updateField('subtitle_eng', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xl="6" lg="6" md="6" sm="12">
        <!-- 키워드(국문) -->
        <v-text-field
          :value="localPaper.keyword"
          :label="$t('label.keyword')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :readonly="readonly"
          @input="updateField('keyword', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xl="6" lg="6" md="6" sm="12">
        <!-- 키워드(영문) -->
        <v-text-field
          :value="localPaper.keyword_eng"
          :label="$t('label.keyword_eng')"
          hide-details="auto"
          class="mb-4 ml-3 mr-3"
          :readonly="readonly"
          @input="updateField('keyword_eng', $event)"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            v-if="!readonly && localPaper.journal.journal_type.code === 'abst'"
          >
            <!-- 초록(국문) -->
            <submission-editor-card
              :value="localPaper.abstract"
              @update-content="updateField('abstract', $event)"
              class="mb-4"
              :height="500"
              :readonly="readonly"
              :comments="localPaper.comments"
              @update:comments="localPaper.comments = $event"
            >
              <template v-slot:card-header>
                <div class="d-flex justify-space-between align-center">
                  <v-card-title class="text-subtitle-1 font-weight-medium">
                    {{ $t("label.abstract") }}
                  </v-card-title>
                  <v-btn
                    color="primary"
                    outlined
                    @click="showPreviewModal = true"
                    class="mr-4"
                  >
                    {{ $t("label.preview") }}
                  </v-btn>
                </div>
              </template>
            </submission-editor-card>
          </v-col>

          <v-col
            cols="12"
            v-if="!readonly && localPaper.journal.journal_type.code != 'abst'"
          >
            <!-- 본문(국문) -->
            <submission-editor-card
              :value="localPaper.content"
              @update-content="updateField('content', $event)"
              class="mb-4"
              :readonly="readonly"
              :height="800"
              :comments="localPaper.comments"
              @update:comments="localPaper.comments = $event"
            >
              <template v-slot:card-header>
                <div class="d-flex justify-space-between align-center">
                  <v-card-title class="text-subtitle-1 font-weight-medium">
                    {{ $t("label.content") }}
                  </v-card-title>
                  <v-btn
                    color="primary"
                    outlined
                    @click="showPreviewModal = true"
                    class="mr-4"
                  >
                    {{ $t("label.preview") }}
                  </v-btn>
                </div>
              </template>
            </submission-editor-card>
          </v-col>

          <!-- 주석 -->
          <v-col cols="12" xl="12" lg="12" md="12" sm="12" v-if="!readonly">
            <!-- 제목 -->
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex flex-column">
                <h4 class="text-subtitle-1 font-weight-medium">
                  {{ $t("label.comment") }}
                </h4>
                <div class="d-flex flex-row align-center mb-2">
                  <v-icon color="orange" size="small">
                    mdi-information-outline
                  </v-icon>
                  <p class="text-subtitle-2 font-weight-regular ml-1 mb-0">
                    {{ $t("txt.add_paper_comment_description") }}
                  </p>
                </div>
              </div>
              <v-btn
                color="green"
                small
                icon
                @click="handleAddComment"
                :disabled="
                  readonly || localPaper.journal.journal_type.code === 'abst'
                "
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>

            <!-- 주석 목록 -->
            <v-card outlined height="400" class="rounded-lg overflow-y-auto">
              <v-card-text>
                <v-card
                  v-for="(comment, index) in localPaper.comments"
                  :key="index"
                  class="ma-1 rounded-lg"
                  outlined
                >
                  <v-card-text>
                    <div class="d-flex justify-space-between">
                      <div class="d-flex flex-row">
                        <v-text-field
                          v-model="comment.page"
                          label="페이지"
                          type="number"
                          outlined
                          dense
                          class="mr-2"
                          :rules="readonly ? [] : [rules.required]"
                          :readonly="readonly"
                        ></v-text-field>
                        <v-text-field
                          v-model="comment.superscript"
                          label="첨자"
                          outlined
                          dense
                          :rules="readonly ? [] : [rules.required]"
                          :readonly="readonly"
                        ></v-text-field>
                      </div>

                      <div class="d-flex flex-row" v-if="!readonly">
                        <v-btn
                          text
                          color="success"
                          @click="handleSaveComment(comment)"
                          class="mr-2"
                        >
                          {{ $t("button.save") }}
                        </v-btn>

                        <v-btn
                          text
                          color="pink"
                          @click="handleDeleteComment(comment, index)"
                          class="mr-2"
                        >
                          {{ $t("button.delete") }}
                        </v-btn>
                      </div>
                    </div>
                    <!-- <v-textarea
                      v-model="comment.content"
                      label="내용"
                      :rules="readonly ? [] : [rules.required]"
                      :readonly="readonly"
                      outlined
                      dense
                    ></v-textarea> -->

                    <submission-editor-card
                      :value="comment.content"
                      @update-content="comment.content = $event"
                      :height="200"
                      :readonly="readonly"
                    >
                      <template v-slot:card-header>
                        <v-card-title
                          class="text-subtitle-2 font-weight-medium pa-2"
                        >
                          내용
                        </v-card-title>
                      </template>
                    </submission-editor-card>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <label class="text-subtitle-1 font-weight-medium mr-3">{{
              $t("label.upload_plagiarism_check_result")
            }}</label>
            <span class="d-flex flex-row align-center mb-2">
              <v-icon color="orange" size="small"
                >mdi-information-outline</v-icon
              >
              <p class="text-subtitle-2 font-weight-regular ml-1 mb-0">
                {{ $t("txt.similarity_check_description") }}
              </p>
            </span>
            <file-input
              class="ml-3 mr-3"
              :initialFilePath="localPaper.file_path"
              @update-saved-file-path="updateSavedFilePath"
              :readonly="readonly"
              :category="'paper'"
              :acceptExtensions="['pdf']"
            ></file-input>
          </v-col>
        </v-row>
      </v-col>

      <!-- 버튼 영역 -->
      <v-row class="mt-12">
        <v-col v-if="!readonly" cols="12" class="d-flex justify-space-between">
          <div>
            <v-btn
              color="grey darken-3"
              rounded
              large
              elevation="0"
              class="mr-2"
              dark
              @click="handleClose"
            >
              {{ $t("button.close") }}
            </v-btn>

            <v-btn
              color="red"
              rounded
              large
              elevation="0"
              dark
              @click="handleTemporarySave"
            >
              {{ $t("button.temporary_save") }}
            </v-btn>
          </div>

          <div>
            <v-btn
              color="primary"
              rounded
              large
              elevation="0"
              dark
              @click="handleSubmit"
            >
              {{ $t("button.submit") }}
            </v-btn>
          </div>
        </v-col>
        <v-col v-else cols="12" class="d-flex justify-end">
          <v-btn
            color="grey darken-3"
            rounded
            large
            elevation="0"
            class="mr-2"
            dark
            @click="handleClose"
          >
            {{ $t("button.close") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-row>

    <!-- 미리보기 모달 -->
    <v-dialog v-model="showPreviewModal" max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">{{ $t("label.preview") }}</span>
          <v-btn icon @click="showPreviewModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6" style="max-height: 800px">
          <div class="d-flex justify-center align-center">
            <div ref="pdfContent">
              <component
                :is="selectedPdfTemplate"
                :item="localPaper"
                :journal="localPaper.journal"
                :startPageNumber="startPageNumber"
              />
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showPreviewModal = false">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import CustomButton from "@/components/common/buttons/CustomButton.vue";
import SubmissionEditorCard from "@/components/common/Cards/SubmissionEditorCard.vue";

import FileInput from "@/components/common/input/FileInput.vue";

import ArticlePaperPage from "@/components/Templates/article/ArticlePaperPage.vue";
import AbstractPaperPage from "@/components/Templates/abstract/AbstractPaperPage.vue";
import ProceedingsPaperPage from "@/components/Templates/proceedings/ProceedingsPaperPage.vue";
import ArticlePreviewTemplate from "@/components/Templates/ArticlePreviewTemplate.vue";

import { closePopup, savePopup, submitPopup } from "@/fields/paper/popups";

import { openIframePrintPreview } from "@/utils/pdfGenerator";

import { paperCommentApi } from "@/api/api";

export default {
  name: "write-paper-content",
  components: {
    // CustomButton,
    SubmissionEditorCard,
    FileInput,
    ArticlePaperPage,
    AbstractPaperPage,
    ProceedingsPaperPage,
    ArticlePreviewTemplate,
  },
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    paper: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    previousPapers: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      localPaper: {},
      savedFilePath: null,
      showPreviewModal: false,
      rules: {
        required: (value) => !!value || this.$t("valid.required_field"),
      },
    };
  },
  methods: {
    /********************************************************************************
     * 버튼 액션
     *********************************************************************************/
    toSubmissionStatus() {
      this.$router.push({
        name: "submission-status",
      });
    },
    handleAddComment() {
      if (!this.localPaper?.comments) {
        this.localPaper.comments = [];
      }

      this.localPaper.comments.push({
        page: null,
        superscript: null,
        content: null,
      });
    },

    async handleSaveComment(comment) {
      if (
        comment.page === null ||
        comment.superscript === null ||
        comment.content === null
      ) {
        this.notifyVue({
          message: this.$t("alert.paper_comment_required"),
          style: "danger",
        });
        return;
      }

      if (comment.idx) {
        await this.updatePaperComment(comment);
      } else {
        await this.createPaperComment(comment);
      }
      await this.getPaperComments();
    },
    async handleDeleteComment(comment, index) {
      if (comment.idx) {
        await this.deletePaperComment(comment);
        await this.getPaperComments();
      } else {
        this.localPaper.comments.splice(index, 1);
      }
    },
    selectPreviousPaper(paper) {
      this.$emit("selectPreviousPaper", paper);
    },
    generatePdfPreview() {
      const element = this.$refs.pdfContent;

      if (!element) {
        // eslint-disable-next-line no-console
        console.error("PDF 콘텐츠 요소를 찾을 수 없습니다.");
        return;
      }

      openIframePrintPreview({ element: element, title: "논문 미리보기" });
    },
    async handleTemporarySave() {
      const isConfirmed = await savePopup();

      if (!isConfirmed) {
        return;
      }

      if (this.localPaper.title === "") {
        this.notifyVue({
          message: this.$t("alert.title_required"),
          style: "danger",
        });
        return;
      }

      if (this.localPaper.title_eng === "") {
        this.notifyVue({
          message: this.$t("alert.title_eng_required"),
          style: "danger",
        });
        return;
      }

      this.localPaper.status = "IN_PROGRESS";
      this.$emit("update", this.localPaper);
    },
    async handleSubmit() {
      const isConfirmed = await submitPopup();

      if (!isConfirmed) {
        return;
      }

      if (this.localPaper.title === "") {
        this.notifyVue({
          message: this.$t("alert.title_required"),
          style: "danger",
        });
        return;
      }

      if (this.localPaper.title_eng === "") {
        this.notifyVue({
          message: this.$t("alert.title_eng_required"),
          style: "danger",
        });
        return;
      }

      this.localPaper.status = "COMPLETED";
      this.$emit("submit", { ...this.localPaper });
    },
    async handleClose() {
      if (this.readonly) {
        this.toSubmissionStatus();
        return;
      }

      const isConfirmed = await closePopup();

      if (!isConfirmed) {
        return;
      }

      this.toSubmissionStatus();
    },
    updateField(field, value) {
      this.localPaper[field] = value;
    },
    updateSavedFilePath(newPath) {
      this.localPaper.file_path = newPath;
      this.$emit("update", { ...this.localPaper });
    },
    /********************************************************************************
     * API 호출 메서드
     *********************************************************************************/
    /**
     * 주석 저장 메서드
     */
    async createPaperComment(comment) {
      try {
        const body = {
          ...comment,
          paper_idx: this.localPaper.idx,
        };
        await paperCommentApi.createPaperComment(body);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }
    },
    /**
     * 주석 수정 메서드
     */
    async updatePaperComment(comment) {
      try {
        await paperCommentApi.updatePaperComment(comment);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }
    },
    /**
     * 주석 삭제 메서드
     */
    async deletePaperComment(comment) {
      try {
        await paperCommentApi.deletePaperComment(comment);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }
    },

    async getPaperComments() {
      try {
        const params = {
          paper_idx: this.localPaper.idx,
        };
        const response = await paperCommentApi.getPaperComments(params);
        if (response.status === 200) {
          this.localPaper.comments = response.data.response;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    updatePreview() {
      this.$forceUpdate(); // Vue의 강제 업데이트 메서드를 사용하여 컴포넌트를 다시 렌더링
    },

    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  watch: {
    paper: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.localPaper = JSON.parse(JSON.stringify(newValue));
      },
    },
  },
  computed: {
    selectedPdfTemplate() {
      if (this.localPaper.journal?.journal_type?.code === "abst") {
        return "abstract-paper-page";
      } else if (this.localPaper.journal?.journal_type?.code === "procs") {
        return "proceedings-paper-page";
      }
      // return "article-paper-page";
      return "article-preview-template";
    },
    startPageNumber() {
      if (this.localPaper?.journal?.journal_type?.code === "jnl") {
        return 2;
      }
      return 1;
    },
  },
};
</script>
